import axios from 'axios';

export default {
    getChancellorProb () {
        return axios.get('/forecast/fact_chancellor_prob.json');
    },
    getEventProb () {
        return axios.get('/forecast/fact_event_prob.json');
    },
    getPartOfGovernment () {
        return axios.get('/forecast/fact_part_of_government.json');
    },
    getCoalitionProb () {
        return axios.get('/forecast/fact_coalition_prob.json');
    },
    getForecast () {
        return axios.get('/forecast/fact_forecast.json');
    },
    getForecastAll () {
        return axios.get('/forecast/fact_forecast_all.json');
    },
    getLastUpdate () {
        return axios.get('/forecast/lastUpdate.json');
    },
    getSurvey () {
        return axios.get('/forecast/fact_survey.json');
    }
};
